<template>
  <div class="DataExportCard pa-4">
    <h1>{{ title }}</h1>

    <p>{{ text }}</p>

    <section class="pb-4 pt-2">
      <div
        v-for="(checkbox, index) in checkboxes"
        :key="index"
        class="mb-4"
      >
        <BaseCheckbox
          :label="checkbox.label"
          :checked="isChecked(checkbox)"
          @input="bindWithCheckboxesList(checkbox, $event)"
        />
      </div>
    </section>

    <button class="base-btn base-btn--blue mb-1" @click="downloadData">Завантажити файл</button>
  </div>
</template>

<script>
export default {
  name: 'DataExportCard',
  props: {
    title: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '',
    },
    checkboxes: {
      type: Array,
      default: () => [],
    },
    onDownloadClick: {
      type: Function,
      default: () => null,
    },
  },
  data() {
    return {
      activeCheckboxes: [],
    };
  },
  methods: {
    isChecked(checkbox) {
      return !!this.activeCheckboxes.find(c => c.label === checkbox.label);
    },
    bindWithCheckboxesList(checkbox, checked) {
      if (checked) this.activeCheckboxes.push(checkbox);
      else {
        const idx = this.activeCheckboxes.findIndex(el => el.label === checkbox.label);
        this.activeCheckboxes.splice(idx, 1);
      }
    },
    downloadData() {
      this.onDownloadClick({ activeCheckboxes: this.activeCheckboxes });
    },
  },
};
</script>
